export function ProfileSection({ title, canEdit, editing, onEdit, onCancel, onSave, saving, children }) {
  return (
    <div className="card">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <div style={{ fontSize: 13, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.6, color: '#37474f' }}>
          {title}
        </div>
        {canEdit && !editing && (
          <button onClick={onEdit} className="btn-secondary" style={{ fontSize: 11, padding: '3px 10px' }}>Edit</button>
        )}
        {editing && (
          <div style={{ display: 'flex', gap: 6 }}>
            <button onClick={onSave} disabled={saving}
              style={{ background: 'var(--forest)', color: '#fff', border: 'none', borderRadius: 6, padding: '4px 12px', fontSize: 11, fontWeight: 600, cursor: 'pointer', opacity: saving ? 0.5 : 1 }}>
              {saving ? 'Saving…' : 'Save'}
            </button>
            <button onClick={onCancel} className="btn-secondary" style={{ fontSize: 11, padding: '3px 10px' }}>Cancel</button>
          </div>
        )}
      </div>
      {children}
    </div>
  );
}
